import { isNumber, isString } from 'lodash'

/**
 * Sorting function used to sort values based on their type in mobile and tablet tables
 * This function is used only for tablet and mobile tables
 */
export const mobileSortFn = <T extends string | number>(itemA: T, itemB: T): number => {
  if (isNumber(itemA) && isNumber(itemB)) {
    return itemA - itemB
  }

  if (isString(itemA) && isString(itemB)) {
    return itemA.localeCompare(itemB)
  }

  return 0
}
